import {
  MEMBER_REQUEST_SET,
  MEMBER_REQUEST_REMOVE,
} from './types';

export const removeMemberRequest = () => ({
  type: MEMBER_REQUEST_REMOVE,
});

export const setMemberRequest = props => ({
  type: MEMBER_REQUEST_SET,
  data: props,
});



// WEBPACK FOOTER //
// ./src/app/actions/member-request/index.js